import { esc } from "./utils.js";

/**
 * A promise-based confirmation modal.
 *
 * Replaces window.confirm() for destructive actions. Native confirm can't
 * show what is about to be deleted, can't distinguish "delete your own
 * post" from "remove another diver's post as a moderator", and can't
 * style the confirm button as dangerous — all of which matter more once
 * a single click can remove somebody else's content.
 *
 * Resolves true if confirmed, false on cancel, backdrop click or Escape.
 */
export function confirmAction({
  title = "Are you sure?",
  body = "",
  detail = "",
  confirmLabel = "Delete",
  variant = "danger",
} = {}) {
  return new Promise((resolve) => {
    const host = document.createElement("div");
    host.innerHTML = `
      <div class="modal fade" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">${esc(title)}</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <p class="mb-2">${esc(body)}</p>
              ${detail
                ? `<blockquote class="border-start border-3 ps-3 text-slate small mb-0 dc-user-text">${esc(detail)}</blockquote>`
                : ""}
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">Cancel</button>
              <button type="button" class="btn btn-${esc(variant)}" data-confirm>${esc(confirmLabel)}</button>
            </div>
          </div>
        </div>
      </div>`;
    const el = host.firstElementChild;
    document.body.appendChild(el);
    const modal = new bootstrap.Modal(el);

    let answer = false;
    el.querySelector("[data-confirm]").addEventListener("click", () => {
      answer = true;
      modal.hide();
    });
    // Resolve on hide rather than on click, so dismissing by Escape or
    // backdrop resolves false exactly once and the node is always removed.
    el.addEventListener("hidden.bs.modal", () => {
      el.remove();
      resolve(answer);
    });
    modal.show();
  });
}
